import { StatelessComponent } from 'react'
import * as styles from 'components/features/pfm/RedemptionForm/CancelButton.css'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { REWARDS_PAGE } from 'constants/pages'
import Button from 'components/features/pfm/Button/Button'

const CancelButton: StatelessComponent = () => {
  return (
    <div className={ styles.cancelButton }>
      <NavigationLink to={ REWARDS_PAGE } className={ styles.link }>
        <Button style='textOnly' size='micro' qaMarker='cancel-button'>
          Cancel
        </Button>
      </NavigationLink>
    </div>
  )
}

export default CancelButton
